import { portalAuthHttpClient } from '../utils/HttpRequestUtils'
import envConfigs from '../configs/envConfigs'

export const getSaveDraftResponse = async (data) => {
    const url = `${envConfigs.baseUrl}${envConfigs.saveDraftUrl}`
    const response = await portalAuthHttpClient.post(url, data)
	return response.data
}
